import { createFileRoute } from "@tanstack/react-router"
import { BroadcastPanel } from "@/features/live-events-admin/broadcast/BroadcastPanel"

export const Route = createFileRoute("/live-events/$eventId/broadcast")({
	component: BroadcastPage,
})

function BroadcastPage() {
	const { eventId } = Route.useParams()
	return <BroadcastPanel eventId={eventId} />
}
